import { __awaiter } from '../_virtual/_tslib.js';
import { Cookies } from 'react-cookie';
import { COOKIES, FB_PIXEL_ID, FB_CAPI_TOKEN } from '../constants/misc.js';

function uaSendEvent(params) {
    var _a, _b, _c, _d;
    const ga = window.ga;
    if (!ga) {
        return;
    }
    const trackerName = (_d = (_c = (_b = (_a = ga.getAll) === null || _a === void 0 ? void 0 : _a.call(ga)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.get) === null || _d === void 0 ? void 0 : _d.call(_c, "name");
    if (!trackerName) {
        return;
    }
    ga(`${trackerName}.send`, Object.assign({ hitType: "event" }, params));
}
function ga4sendEvent(eventName, params) {
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("event", eventName, params);
}
function gaSendEvent(params) {
    uaSendEvent(params);
}
function ga4SetUser(userId) {
    const cookies = new Cookies();
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("set", { user_id: cookies.get(COOKIES.userId) });
}
function moEngageUserAttributeTrack(attribute, value) {
    const moEngage = window["Moengage"];
    if (attribute && value && moEngage) {
        moEngage.add_user_attribute(attribute, value);
    }
}
function moEngageUserEventTrack(eventName, attributes) {
    const moEngage = window["Moengage"];
    if (eventName && attributes && moEngage) {
        moEngage.track_event(eventName, attributes);
    }
}
function moEngageUserLogIn(userId) {
    const moEngage = window["Moengage"];
    if (userId && moEngage) {
        moEngage.add_unique_user_id(userId);
    }
}
function moEngageUserLogOut() {
    const moEngage = window["Moengage"];
    if (moEngage) {
        moEngage.destroy_session();
    }
}
function moEngageUserPhoneNum(phoneNum) {
    const moEngage = window["Moengage"];
    if (phoneNum && moEngage) {
        moEngage.add_mobile(phoneNum);
    }
}
function sendPageSenseEvent(eventName) {
    window.pagesense = window.pagesense || [];
    const pagesense = window["pagesense"];
    if (pagesense) {
        window.pagesense.push(["trackEvent", eventName]);
    }
}
function getFBEventId(id, companyId) {
    const suffix = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    return [id, companyId, suffix].filter((part) => part != null && part !== "").join("_");
}
function sendFbCapiEvent(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const cookies = new Cookies();
        const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
        const sha256 = (yield import('crypto-js/sha256')).default;
        const urlencoded = new URLSearchParams();
        if (ENV !== "production") {
            urlencoded.append("test_event_code", "TEST15638");
        }
        const currLocObj = cookies.get(COOKIES.currentLoc);
        let currCity;
        if (currLocObj) {
            currCity = currLocObj.name;
        }
        urlencoded.append("data", JSON.stringify([
            {
                event_id: params.event_id,
                event_name: params.event_name,
                event_time: Math.round(new Date().getTime() / 1000),
                action_source: "website",
                event_source_url: window.location.href,
                user_data: {
                    ph: params.phone_num ? sha256(String(params.phone_num)).toString() : undefined,
                    ct: currCity ? sha256(currCity).toString() : undefined,
                    country: sha256(String("in")).toString(),
                    fbp: cookies.get("_fbp") ? cookies.get("_fbp") : undefined,
                    fbc: cookies.get("_fbc") ? cookies.get("_fbc") : undefined
                },
                custom_data: params.custom_data
            }
        ]));
        fetch(`https://graph.facebook.com/v23.0/${FB_PIXEL_ID}/events?access_token=${FB_CAPI_TOKEN}`, {
            method: "POST",
            body: urlencoded,
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
        });
    });
}

export { ga4SetUser, ga4sendEvent, gaSendEvent, getFBEventId, moEngageUserAttributeTrack, moEngageUserEventTrack, moEngageUserLogIn, moEngageUserLogOut, moEngageUserPhoneNum, sendFbCapiEvent, sendPageSenseEvent };
//# sourceMappingURL=user-analytics.service.js.map
